const CHUNK = 8 * 1024 * 1024; // multiple of 256 KB, as Google requires
const wait = (ms) => new Promise((r) => setTimeout(r, ms));

const putChunk = async (url, file, start, end) => {
  const range = end > start ? `bytes ${start}-${end - 1}/${file.size}` : `bytes */${file.size}`;
  try { return await fetch(url, { method: "PUT", headers: { "Content-Range": range }, body: end > start ? file.slice(start, end) : null }); }
  catch { return null; }
};

const nextOffset = (res, fallback) => {
  const r = res.headers.get("Range");
  return r ? parseInt(r.split("-")[1], 10) + 1 : fallback;
};

// Sends the file straight to Google Drive's resumable session in chunks, resuming after network drops.
export async function uploadToDrive(url, file, onProgress) {
  let offset = 0;
  let fails = 0;
  while (true) {
    const end = Math.min(offset + CHUNK, file.size);
    const res = await putChunk(url, file, offset, end);
    if (res && (res.status === 200 || res.status === 201)) { onProgress(1); return res.json(); }
    if (res && res.status === 308) { offset = nextOffset(res, end); fails = 0; onProgress(offset / file.size); continue; }
    if (res && res.status === 404) throw new Error("The upload session expired. Please start the upload again.");
    if (++fails > 6) throw new Error("The upload keeps getting interrupted. Check your connection and try again.");
    await wait(1000 * 2 ** fails);
    const status = await putChunk(url, file, 0, 0);
    if (status && (status.status === 200 || status.status === 201)) { onProgress(1); return status.json(); }
    if (status && status.status === 308) offset = nextOffset(status, 0);
  }
}
